import CountryData from "i18n-iso-countries";
import CountryDataDe from "i18n-iso-countries/langs/de";

CountryData.registerLocale(CountryDataDe);
